import React from 'react';
import { useQueryClient } from 'react-query';
import NumberFormat from 'react-number-format';
import { omit, filter } from 'lodash';
import { useCurrencies } from "../services/currencies";

const CurrencyValue = props => {

  //see https://github.com/s-yadav/react-number-format#values-object for prop details
  const filteredProps = omit(props, filter(Object.keys(props), (key) => [
    'isNumericString',
    'thousandSeparator',
    'decimalSeparator',
    'thousandsGroupStyle',
    'decimalScale',
    'fixedDecimalScale',
    'format',
    'prefix',
    'suffix',
  ].indexOf(key) < 0));

  const controlProps = {
    isNumericString: false,
    thousandSeparator: ',',
    decimalSeparator: '.',
    thousandsGroupStyle: 'thousand',
    decimalScale: undefined, //number of decimal places
    fixedDecimalScale: false, // show the trailing zeroes
    type: 'text',
    displayType: "text",
    format: undefined, //can use # where a number is to be entered.
    prefix: undefined,
    suffix: undefined,
    ...filteredProps
  }

  const queryClient = useQueryClient();
//TODO: Need option to pass in a date to use for the currency lookup
  const currency = useCurrencies({queryClient, extraKeys: [props.currencyCode || 'USD'], useCache: true });
 
  let currencySymbol = "";
  if (!currency.isLoading && !currency.error && currency.data && currency.data.length === 1) {
    currencySymbol = currency.data[0].currencySymbol;
  }

  return (
    <div style={{display:"inline", ...props.style}}>
      <span>{currencySymbol}&nbsp;</span>
      < NumberFormat
        {...controlProps}
        value={props.value}
      />
    </div>
  )

}

export default CurrencyValue;